import { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import useOuterClick from '../../hooks/useOuterClick';
import { EllipsisIcon, QuestionBubbleIcon, TextIcon } from '../Icon/Icon';
import {
  TextStyled,
  WidgetButtonStyled,
  WidgetRowStyled,
  WidgetWrapperStyled,
} from './MobileWidget.styled';

type MobileWidgetPropsT = {
  onClickFaqButton: () => void;
};

const MobileWidget: React.FC<MobileWidgetPropsT> = ({ onClickFaqButton }) => {
  const [isOpen, setIsOpen] = useState(false);
  const widgetRef = useRef<HTMLDivElement>(null);

  useOuterClick(() => setIsOpen(false), widgetRef);

  return (
    <WidgetWrapperStyled ref={widgetRef}>
      {isOpen && (
        <>
          <WidgetRowStyled>
            <TextStyled>
              <FormattedMessage id="button.FAQ" defaultMessage="Faq" />
            </TextStyled>

            <WidgetButtonStyled isInverted onClick={onClickFaqButton}>
              <QuestionBubbleIcon width="20px" height="20px" />
            </WidgetButtonStyled>
          </WidgetRowStyled>

          <WidgetRowStyled>
            <TextStyled>
              <FormattedMessage id="common.giveFeedback" defaultMessage="Give feedback" />
            </TextStyled>

            <a href="mailto:contact@wayaj.com">
              <WidgetButtonStyled isInverted>
                <TextIcon />
              </WidgetButtonStyled>
            </a>
          </WidgetRowStyled>
        </>
      )}

      <WidgetRowStyled>
        <WidgetButtonStyled isInverted onClick={() => setIsOpen(!isOpen)}>
          <EllipsisIcon />
        </WidgetButtonStyled>
      </WidgetRowStyled>
    </WidgetWrapperStyled>
  );
};

export default MobileWidget;
